import {
  ActorRole,
  TakeDealControlDocument,
} from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { editionModeState } from '@/states/edition-mode.state';
import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';

export function useTakeDealControl(dealId: string) {
  const setEditionMode = useSetAtom(editionModeState);
  const [takeDealControlMutation, { loading, error }] = useMutation(
    TakeDealControlDocument
  );

  const takeDealControl = async () => {
    const result = await takeDealControlMutation({
      variables: { dealId },
    });

    const response = result.data?.takeDealControl;
    if (response?.__typename === 'DomainException') {
      throw new Error(response.code);
    }

    setEditionMode(ActorRole.Choose);
    trackEvent('DEAL_CONTROL_TAKEN', { dealId });
    return result;
  };

  return {
    takeDealControl,
    loading,
    error,
  };
}
